import React from "react";

function notificaions() {
  return (
    <h1
      style={{
        fontSize: "2rem",
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      No Notifications Yet!! 🎈
    </h1>
  );
}

export default notificaions;
